export default "__VITE_ASSET__DlXUrbP6__"